import { FC, PropsWithChildren, ReactNode, useState } from 'react';
import { cn } from '@/utils/classNames.ts';
import AppLogo from '@/components/ui/AppLogo/AppLogo.tsx';
import { PropsWithClassName } from '@/types/PropsWithClassName';
import ExplainerVideoModal from '@/components/modals/ExplainerVideoModal.tsx';

type BrandCardSideContentProps = PropsWithClassName & { topRight?: ReactNode; wide?: boolean };

const BrandCardSideContent: FC<PropsWithChildren<BrandCardSideContentProps>> = ({
  children,
  className,
  topRight,
  wide = false,
}) => {
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  return (
    <>
    <div
      className={cn(
        'grid grid-cols-2 rounded-2xl max-w-full w-[1048px] md:min-h-[500px] lg:min-h-[624px]',
        wide ? 'md:grid-cols-[2fr_3fr]' : 'md:grid-cols-2',
        className
      )}
      style={{ boxShadow: 'rgba(0, 0, 0, 0.1) 0px 8px 10px -6px, rgba(0, 0, 0, 0.1) 0px 5px 22px 18px' }}
    >
      <div className="col-span-2 md:col-span-1 flex flex-col items-center justify-center p-5 md:p-8 bg-[#FED32C] rounded-l-2xl rounded-r-2xl md:rounded-r-none gap-6">
        <AppLogo.LogoOnly className="w-[200px] md:w-[300px] max-w-full" />
        <div className="text-center space-y-1 max-w-[300px]">
          <p className="text-sm md:text-base font-semibold text-[#5C4A00]">
            CareTailor . Fixing care starts here
          </p>
          <p className="text-sm md:text-base font-semibold text-[#5C4A00]">
            Share it. Tell Others. Join the waitlist
          </p>
          <a 
            href="https://www.caretailor.co.uk" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-sm md:text-base font-semibold text-[#5C4A00] underline hover:opacity-70 inline-block"
          >
            www.caretailor.co.uk
          </a>
        </div>
        <p className="text-center text-sm md:text-base font-semibold text-[#5C4A00] max-w-[340px]">
          Need help getting set up?{' '}
          <button
            type="button"
            onClick={() => setIsVideoOpen(true)}
            className="underline hover:opacity-70 font-semibold"
          >
            Click Here
          </button>{' '}
          to watch a short explainer video!
        </p>
      </div>
      <div className="col-span-2 md:col-span-1 relative flex flex-col justify-center bg-white items-center gap-4 p-4 lg:p-10 rounded-r-2xl">
        {topRight && (
          <div className="absolute top-4 right-4">
            {topRight}
          </div>
        )}
        {children}
      </div>
    </div>
    <ExplainerVideoModal isOpen={isVideoOpen} onClose={() => setIsVideoOpen(false)} />
    </>
  );
};

export default BrandCardSideContent;
